import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  setPaymentMethod
} from 'actions/visits'
import {
  openModal,
  closeModal
} from 'actions/modals'
import {
  declineVisit,
  createVisit,
  getVisitCreationOptions,
  joinVisit,
  acceptVisit,
  cancelVisit
} from 'actions/api/visits'
import { BILLING_HANDSHAKE_MODAL } from 'constants/modals'
import BillingModal from 'components/BillingModal'
import { isEmpty } from 'lodash'

export class BillingModalContainer extends Component {

  componentDidMount() {
    const {
      isInitiator,
      appointmentId
    } = this.props
    if (isInitiator) {
      this.props.getVisitCreationOptions(appointmentId)
    } else {
      this.props.joinVisit(appointmentId)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isInitiator,
      openModal,
      isVisManager,
      scheduledEndTime,
      isWebSocketConnected
    } = this.props

    const optionsReceived = !prevProps.scheduledEndTime && scheduledEndTime
    const connectedToWebSocket = !prevProps.isWebSocketConnected && isWebSocketConnected

    if (isVisManager) {
      this.handleVisManagerVisit(isInitiator, optionsReceived, connectedToWebSocket)
    } else {
      if (optionsReceived) {
        openModal()
      }
    }
  }

  handleVisManagerVisit(isInitiator, optionsReceived, connectedToSocket) {
    if (isInitiator && optionsReceived) {
      this.props.createVismgrVisit()
    } else if (!isInitiator && connectedToSocket){
      this.props.acceptVisit()
    }
  }

  render() {
    const {
      modalOpened,
      closeModal,
      paymentMethod,
      setPaymentMethod,
      rate,
      balance,
      isInitiator,
      maximumDuration,
      otherUser,
      doNotRecord,
      createVisit,
      visitInfo,
      declineVisit,
      acceptVisit,
      cancelVisit,
      redirectURL,
      confirmDialog
    } = this.props


    return (
      <BillingModal
        show={modalOpened}
        closeModal={closeModal}
        payment={paymentMethod}
        setPayment={setPaymentMethod}
        rate={rate}
        couponAll={balance.coupons && balance.coupons.universal}
        couponLocal={balance.coupons && balance.coupons.local}
        couponRemote={balance.coupons && balance.coupons.remote}
        balance={balance.money}
        isInitiator={isInitiator}
        maximumDuration={maximumDuration}
        otherUser={otherUser}
        doNotRecord={doNotRecord}
        payer={!isInitiator && rate === null && isEmpty(balance)}
        createVisit={createVisit}
        visitInfo={visitInfo}
        declineVisit={declineVisit}
        acceptVisit={acceptVisit}
        cancelVisit={cancelVisit}
        redirectURL={redirectURL}
        confirmDialog={confirmDialog}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    modalOpened: state.modal.currentModal === BILLING_HANDSHAKE_MODAL,
    paymentMethod: state.payment.paymentMethod,
    rate: state.payment.rate,
    balance: state.payment.balance,
    appointmentId: state.visit.appointmentId,
    maximumDuration: state.visit.maxDuration,
    otherUser: state.visit.recipientName,
    doNotRecord: !state.visit.allowedToRecord,
    inmateDeviceIds: state.visit.inmateDeviceIds,
    visitorDeviceIds: state.visit.visitorDeviceIds,
    deviceId: state.visit.deviceId,
    redirectURL: state.visit.redirectURL,
    scheduledEndTime: state.visit.scheduledEndTime,
    isWebSocketConnected: state.visit.isWebSocketConnected
  }
}

function mapDispatchToProps (dispatch) {
  return {
    setPaymentMethod: (paymentMethod) => dispatch(setPaymentMethod(paymentMethod)),
    openModal: () => dispatch(openModal(BILLING_HANDSHAKE_MODAL)),
    closeModal: () => dispatch(closeModal(BILLING_HANDSHAKE_MODAL)),
    declineVisit: (onSuccess) => dispatch(declineVisit(onSuccess)),
    createVisit: (data) => dispatch(createVisit(data)),
    getVisitCreationOptions: (appointmentId) => dispatch(getVisitCreationOptions(appointmentId)),
    joinVisit: (appointmentId) => dispatch(joinVisit(appointmentId)),
    acceptVisit: (paymentMethod) => dispatch(acceptVisit(paymentMethod)),
    cancelVisit: (appointmentId, onSuccess) => dispatch(cancelVisit(appointmentId, onSuccess))
  }
}

function mergeProps (stateProps, dispatchProps, ownProps) {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    createVisit: (paymentData) => {
      const inmateDeviceIds = stateProps.inmateDeviceIds
      const visitorDeviceIds = stateProps.visitorDeviceIds
      const currentDeviceId = stateProps.deviceId
      const visitDetails = { appointmentId: stateProps.appointmentId }
      if (inmateDeviceIds) visitDetails.inmateDeviceIds = inmateDeviceIds
      if (visitorDeviceIds) visitDetails.visitorDeviceIds = visitorDeviceIds
      if (currentDeviceId) visitDetails.currentDeviceId = currentDeviceId
      dispatchProps.createVisit({ ...paymentData, ...visitDetails})
    },
    createVismgrVisit: () => {
      dispatchProps.createVisit({ appointmentId: stateProps.appointmentId })
    },
    cancelVisit: (onSuccess) => { dispatchProps.cancelVisit(stateProps.appointmentId, onSuccess) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(BillingModalContainer)
